import React from "react";
import { Typography, Container, Box, IconButton, Stack } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";

const socialLinks = [
  { name: "Instagram", url: "https://www.instagram.com/la_vitreenne_volley/", icon: <InstagramIcon /> }
];

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                // backgroundColor: "#b71c1ccf",
                backgroundColor: "black",
                color: "white",
                py: 3,
                textAlign: "center",
                mt: "auto"
            }}
        >
            <Container>
                <Typography variant="body2" gutterBottom>Suivez-nous :</Typography>
                <Stack direction="row" justifyContent="center" spacing={2} sx={{ mb: 1 }}>
                    {socialLinks.map((link) => (
                        <IconButton
                            key={link.name}
                            component="a"
                            href={link.url}
                            target="_blank"
                            rel="noopener"
                            aria-label={link.name}
                            sx={{ color: "white" }}
                        >
                            {link.icon}
                        </IconButton>
                    ))}
                </Stack>
                <Typography variant="body2">
                    © {new Date().getFullYear()} Vitréenne Volley-Ball. All Rights Reserved.
                </Typography>
            </Container>
        </Box>
    );
}
